import { useLocation, useParams } from 'react-router-dom'

interface ReportPageUrlState {
  reportId: string | null
  sectionId: string | null
}
export default function useReportPageUrlState(): ReportPageUrlState {
  const location = useLocation()
  const { id, sectionId } = useParams()

  if (location.pathname.startsWith('/reports')) {
    return {
      reportId: id || null,
      sectionId: sectionId || null,
    }
  }
  return {
    reportId: null,
    sectionId: null,
  }
}
